/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 */
import { useBlockProps, RichText } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save( {attributes} ) {
	let props = useBlockProps.save();
	let image = '', title = '';

	if (!!attributes.image) {
		if (!!attributes.url) {
			image = <div className="mio-logo-bar-item__image"><a href={ attributes.url } target="_blank"><img src={ attributes.image } /></a></div>;
		} else {
			image = <div className="mio-logo-bar-item__image"><img src={ attributes.image } /></div>;
		}
	}
	if (!!attributes.title) {
		title = <RichText.Content tagName="p" className="mio-logo-bar-item__title" value={ attributes.title } />;
	}

	return (
		<div { ...props }>
			<div class="mio-logo-bar-item-block-fields">
				{ !!attributes.title && title }	
				{ !!attributes.image && image }
			</div>
		</div>
	);
}
